<template>
    <div>
        <a ref="downloadLink" :download="file.name" :href="file.url"></a>
        <popup-modal-confirm
            v-if="exporting"
            :show-exclamation="false"
            :confirm-text="$t('general.export')"
            :has-close-button="true"
            :title="$t('general.export')"
            :use-portal="true"
            :working="generating"
            :confirm-button="!!checkedFields.length ? 'success' : ''"
            :disabled="!!!checkedFields.length"
            @close="exporting = false"
            @confirm="exportToCSV"
            class="w-600"
        >
            <div class="flex items-center h-48 bg-primary-5 px-16 rounded-6">
                <toggle class="w-1/2" :checked="allSelected" @change="toggleAll">
                    {{ $t('general.select_all') }}
                </toggle>
                <toggle class="ml-6 w-1/2" v-model="withAnonymised">
                    {{ $t('general.with_anonymised') }}
                </toggle>
            </div>
            <div class="my-24">
                <div v-for="(obj, name, index) in exportFields"
                    class="mb-20"
                >
                    <p class="pl-16 text-body-sm font-semibold mb-4">{{ $t(`general.${name}.title`).toUpperCase() }}</p>
                    <div class="masonry-container">
                        <div v-for="(label, key, index) in exportFields[name]"
                             :key="`field-${name}-${key}`"
                             class="flex flex-45"
                        >
                            <toggle v-model="checkedFields"
                                    :value="`${name}.${key}`"
                                    class="my-4"
                            >
                                {{ $t(label) }}
                            </toggle>
                        </div>
                    </div>
                </div>
            </div>

            <a ref="downloadLink" :download="file.name" :href="file.url">
                {{ file.name }}
            </a>
        </popup-modal-confirm>
    </div>
</template>

<script>
import PopupModalConfirm from './ui/PopupModalConfirm.vue';
import SvgIcon from './ui/SvgIcon.vue';
import Loading from './ui/Loading.vue';
import Toggle from "./forms/Toggle";

import * as exportsService from '../services/ExportService';
import * as analytics from '../services/AnalyticsService';
import {mapState, mapActions} from "pinia";
import {useNotificationsStore} from '../state/modules/notifications';
import {useAnalyticsStore} from '../state/modules/analytics';
import {ADD_NOTIFICATION} from "../state/mutation-types";

export default {
    name: 'AnalyticsExport',
    components: {
        Toggle,
        PopupModalConfirm,
        'svg-icon': SvgIcon,
        'loading': Loading,
    },
    props: {
        filters: Object,
    },
    data: function () {
        return {
            withAnonymised: true,
            checkedFields: [],
            exporting: false,
            generating: false,
            file: {
                name: null,
                url: null,
            },
        };
    },
    computed: {
        ...mapState(useAnalyticsStore, ['fields']),
        exportFields() {
            return this.fields
        },
        allSelected() {
            if (!this.exportFields) return false

            let allSelected = true
            for (const [key, fields] of Object.entries(this.exportFields)) {
                for (const [label, field] of Object.entries(fields)) {
                    if (!this.checkedFields.includes(`${key}.${label}`)) {
                        allSelected = false;
                        break;
                    }
                }
                // break everything when there is 1 not-toggled input (performance)
                if (!allSelected) {
                    break;
                }
            }

            return !!allSelected
        },
    },
    methods: {
        ...mapActions(useAnalyticsStore, ['setFields']),
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        toggleAll() {
            if (this.allSelected) {
                this.checkedFields = []
            } else {
                for (const [key, fields] of Object.entries(this.exportFields)) {
                    for (const [label, field] of Object.entries(fields)) {
                        if (!this.checkedFields.includes(`${key}.${label}`))
                            this.checkedFields.push(`${key}.${label}`)
                    }
                }
            }
        },
        exportToCSV() {
            this.generating = true;

            const checkedFields = this.checkedFields,
                 filters = {...this.filters, withAnonymised: this.withAnonymised};

            exportsService.companyExport({
                checkedFields,
                filters,
            }).then(({success}) => {
                this.generating = false;
                this.exporting = false;
                this.$emit('close');

                if (success) {
                    this[ADD_NOTIFICATION]({
                        type: 'notification',
                        message: success,
                    });
                }
            });
        },
        fetchFields() {
            analytics.fields()
                .then(({fields}) => this.setFields(fields))
                .then(() => this.toggleAll())
        },
        startExporting() {
            this.exporting = true;
        }
    },
    watch: {
        'exporting'() {
            if (this.exporting) {
                this.checkedFields = []
                this.toggleAll()
            }
        },
    },
    mounted() {
        this.fetchFields();
    }
};
</script>

<style scoped>
    .masonry-container {
        width: 650px;
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        padding: 0 16px;
    }
    .flex-45 {
        flex: 45%;
    }
</style>
